import { render } from "./DocumentosServicos.vue?vue&type=template&id=5f2fdaf9"
import script from "./DocumentosServicos.vue?vue&type=script&lang=js"
export * from "./DocumentosServicos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__